var exports = {
  "X": "SavedMessagesContent.module__scroller___S3U0LU",
  "W": "SavedMessagesContent.module__messageCard___S3U0LU",
};

module.exports = exports;
